<template>
  <v-layout justify-center>
    <!-- All the items in this group are correct -->
    <v-flex shrink>
      <v-btn
        @click="saveFullCorrect"
        color="green"
        :dark="!fullCorrect.disabled"
        :disabled="fullCorrect.disabled"
        :loading="fullCorrect.loading"
      >
        <v-icon class="pr-2">check</v-icon>
        <span>Categoría completa correcta</span>
      </v-btn>
    </v-flex>
    <!-- Save only the selected items (correct or incorrect) -->
    <v-flex shrink>
      <v-btn
        @click="saveSelected"
        color="cyan"
        :dark="anySelected && !selected.disabled"
        :disabled="!anySelected || selected.disabled"
        :loading="selected.loading"
      >
        <v-icon class="pr-2">save</v-icon>
        <span>Guardar solamente seleccionados</span>
      </v-btn>
    </v-flex>
    <!-- All the items in this group are incorrect -->
    <v-flex shrink>
      <v-btn
        @click="saveFullIncorrect"
        color="red"
        :dark="!fullIncorrect.disabled"
        :disabled="fullIncorrect.disabled"
        :loading="fullIncorrect.loading"
      >
        <v-icon class="pr-2">clear</v-icon>
        <span>Categoría completa incorrecta</span>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";

/**
 * A component to save the predictions of the bradcrumb group.
 */
export default {
  data: () => ({
    fullCorrect: {
      disabled: false,
      loading: false
    },
    fullIncorrect: {
      disabled: false,
      loading: false
    },
    selected: {
      disabled: false,
      loading: false
    }
  }),
  computed: {
    /**
     * Returns true if there is any item selected (correct is true or false but not null or undefined).
     */
    anySelected() {
      return this.categoryItems.some(
        item => item.correct === true || item.correct === false
      );
    },
    ...mapState("classifier", ["categoryItems"])
  },
  methods: {
    ...mapActions("classifier", ["saveCorrection"]),
    async saveFullCorrect() {
      this.fullCorrect.loading = true;
      this.fullIncorrect.disabled = true;
      this.selected.disabled = true;
      await this.saveCorrection({ fullCorrect: true });
      this.fullCorrect.loading = false;
      this.fullIncorrect.disabled = false;
      this.selected.disabled = false;
    },
    async saveFullIncorrect() {
      this.fullIncorrect.loading = true;
      this.fullCorrect.disabled = true;
      this.selected.disabled = true;
      await this.saveCorrection({ fullIncorrect: true });
      this.fullIncorrect.loading = false;
      this.fullCorrect.disabled = false;
      this.selected.disabled = false;
    },
    async saveSelected() {
      this.selected.loading = true;
      this.fullCorrect.disabled = true;
      this.fullIncorrect.disabled = true;
      await this.saveCorrection();
      this.selected.loading = false;
      this.fullCorrect.disabled = false;
      this.fullIncorrect.disabled = false;
    }
  }
};
</script>